// removed by extract-text-webpack-plugin
module.exports = {"container":"container___3eJ6N","wrapper":"wrapper___-R427","logo":"logo___1EsoH","info":"info___2LNGm","modal":"modal___31JJt","header":"header___bHTK4","body":"body___f69qc","close":"close___28U4u","overlay":"overlay___2AVr2","hidden":"hidden___3Ttzm"};


//////////////////
// WEBPACK FOOTER
// ./app/global.scss
// module id = 13
// module chunks = 0